import { render, staticRenderFns } from "./td-IP.vue?vue&type=template&id=70fe14f3&"
import script from "./td-IP.vue?vue&type=script&lang=js&"
export * from "./td-IP.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports